// L'EFFACEUR — Page maintenance
// Activée via env var REACT_APP_MAINTENANCE=true OU via flag en DB (admin toggle)
import { motion } from 'framer-motion';
import { Wrench } from 'lucide-react';

const MaintenancePage = ({ message, eta }) => {
  return (
    <div className="min-h-screen bg-void flex items-center justify-center px-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center max-w-lg">
        <div className="inline-block mb-6 p-5 rounded-full bg-orange-500/10 border border-orange-500/40">
          <Wrench className="w-12 h-12 text-orange-400" />
        </div>
        <p className="font-mono text-orange-400 text-xs mb-4 tracking-wider">// MAINTENANCE_EN_COURS</p>
        <h1 className="font-orbitron text-3xl md:text-4xl font-bold text-white mb-4">
          Le site est temporairement indisponible
        </h1>
        <p className="text-gray-400 mb-6 leading-relaxed">
          {message || "On effectue une mise à jour pour vous offrir une meilleure expérience. Le site revient en ligne dans quelques minutes."}
        </p>
        {eta && (
          <p className="text-cyan-400 font-mono text-sm mb-8">
            Retour estimé : {eta}
          </p>
        )}
        <div className="text-xs text-gray-500 font-mono mt-8">
          En cas d'urgence : <a href="mailto:leffaceur@effaceurpro.fr" className="text-cyan-400 hover:underline">leffaceur@effaceurpro.fr</a>
        </div>
      </motion.div>
    </div>
  );
};

export default MaintenancePage;
